import { createSlice } from "@reduxjs/toolkit";
import { getRSCategoryList } from "../../apis/RealStateApis";

const rsSlices = createSlice({
  name: "realstate",
  initialState: {
    categories: [],
    loading: false,
    isSuccess: false,
  },
  reducers: {},
  extraReducers: {
    [getRSCategoryList.pending]: (state, action) => {
      state.loading = true;
    },
    [getRSCategoryList.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.isSuccess = true;
      state.categories = payload;
    },
    [getRSCategoryList.rejected]: (state, { payload }) => {
      state.loading = false;
      state.isSuccess = false;
    },
  },
});

export default rsSlices.reducer;
